// extracted by mini-css-extract-plugin
export default {"payment_roundedContent":"PaymentRoundedContent_payment_roundedContent__egaIU"};